const translations = {
    amountDue: 'Due: ',
    invoiceNumber: 'Invoice #',
    notSet: 'not set'
};

export default translations;
